import {createAction} from '@ngrx/store';
import {ActiveCollectionsFilterCollection, Alphabet, CollectionCategories} from '../../interfaces/collections-filter.interface';

export const SelectCollectionsCategories = createAction(
  '[COLLECTIONS-FILTER] SELECT_COLLECTIONS_CATEGORIES',
  (payload: CollectionCategories) => payload
);

export const SelectLetter = createAction(
  '[COLLECTIONS-FILTER] SELECT_LETTER',
  (payload: Alphabet) => payload
);

export const CollectCollectionsFilters = createAction(
  '[COLLECTIONS-FILTER] COLLECT_FILTERS',
  (payload: ActiveCollectionsFilterCollection) => payload
);

export const ResetCollectionsFilters = createAction(
  '[COLLECTIONS-FILTER] RESET_FILTERS',
);
